<template>
  <div class="page">
    <div class="layout">
      <el-row>
        <el-col :span="24">
               <el-page-header @back="onBack" title='' content="付款管理">
          </el-page-header>
         
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <div class="search-text">&nbsp;</div>
          <el-date-picker
            type="daterange"
            range-separator="至"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
          >
          </el-date-picker>
        </el-col>
        
        <el-col :span="4">
          <SearchButton :backgroundColor="'#D2D6DE'" :fontColor="'black'">
            <template v-slot:title>導出Excel</template>
          </SearchButton>
        </el-col>
      </el-row>
 
    </div>
  
  </div>
</template>

<script>
import SearchButton from "@/components/iconButton";
export default {
  components: { SearchButton },
  data() {
    return {
      centerDialogVisible: false,
      tableData: [],
    };
  },
  methods: {
    onCancelButton() {
      this.centerDialogVisible = true;
    },
    confirmFunction() {
      this.centerDialogVisible = false;
    },
    onDeleteButton() {
      this.centerDialogVisible = true;
    },
    onAdd() {
      this.$router.push({ path: "/staff/add" });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}
</style>